import { render } from "./ScontiDataTable.vue?vue&type=template&id=09e6973a"
import script from "./ScontiDataTable.vue?vue&type=script&lang=js"
export * from "./ScontiDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__